import { type State, type User } from './types';

export const getUser = ({ firebase }: { firebase: State }): User =>
  firebase.auth;
